<template>
  <el-col v-loading="loading">
    <el-col class="padding_5px_top padding_10px_bottom">
      <el-col class="mainArea">
        <el-col class="text" style="width: 362px;">
          <el-col :span="10" class="database_search" width="140px">
            通过基金代码查询
          </el-col>
          <el-col :span="11" class="left_text_align" id="database_input">
            <el-popover placement="bottom" width="380px" v-model="searchPopoverVisible">
              <el-row style="width: 380px; height: 300px;" v-loading="loading2">
                <el-scrollbar ref="search_scrollbar" style="height: 100%;">
                  <el-row style="
                                        text-align: left;
                                        margin: 0;
                                        font-size: 12px;
                                        cursor: pointer;
                                    " v-for="(node, index) in state" class="fundInformation" :key="index">
                    <el-col :span="24" v-html="node" @click.native="selectFundInfo(node, index)" :ref="'cssClass' + index"
                      @mouseenter.native="
                        changeClass($event, index)
                        " :class="{ searchHover: 1 === index }"></el-col>
                  </el-row>
                </el-scrollbar>
              </el-row>
              <el-input placeholder="请输入基金代码或基金名称" slot="reference" type="text" v-model="symbol"
                @input="searchFundCache(symbol)"></el-input>
            </el-popover>
          </el-col>
        </el-col>

        <el-select v-model="selectedTemplate" clearable placeholder="请选择PDF模板">
          <el-option v-for="item in templates" :key="item.value" :label="item.value" :value="item.value"
            :selectedTemplate="item.value">
          </el-option>
        </el-select>

        <el-button type="primary" @click="searchFundInformation()">查询</el-button>

        <el-button icon="icon_download" @click="downloadReport()" style="margin-left: auto;">下载报告</el-button>

      </el-col>
    </el-col>
    <el-col class="line"></el-col>

    <el-col>
      <div class="iframe-container">
        <div class="iframe-wrapper" style="overflow-x: hidden; overflow-y: auto;">
          <iframe :src="pdfUrl" width="100%" height="910px" style="border: none; overflow: hidden;">
          </iframe>
        </div>
      </div>
    </el-col>

  </el-col>
</template>
<script>
import { Message } from "element-ui";
import axios from 'axios';
const componentsCommon = require("cb-components-common").default;
const getENV = componentsCommon.getENV;
const getToken = componentsCommon.localStorage.getToken;
const getMyListTypeByCustom = componentsCommon.common.getMyListTypeByCustom;
const searchBox = componentsCommon.mixin.searchBox.searchBox;
const exportFile = componentsCommon.mixin.exportFile.exportFile;

export default {
  mixins: [searchBox, exportFile],
  data() {
    return {
      selectedTemplate: '默认模板',
      isModuleVisible: false,
      showSelectTemplate: false,
      searchPopoverVisible: false,
      symbol: "",
      symbolList: [],
      loading: false,
      showAddOrRemoveMyList: false,
      templates: [{
        value: '默认模板',
        layout: ''
      }, {
        value: '股混基金模板',
        layout: '1'
      }, {
        value: '积极债基模板',
        layout: '2'
      }, {
        value: '债券基金模板',
        layout: '3'
      }
        // , {
        // value: '海外基金模板',
        // layout: '4'
        // }
      ],
      fundId: "",
      data: null,
      pdfUrl: '',
      searchFlag: false,
    }
  },

  methods: {
    selectFundInfo(node, index) {
      // 第 0 行是表头或“未找到”提示，不是可选择的基金。
      if (index === 0) return;

      this.getFundInformation(node);
    },

    async downloadReport() {
      if (!this.searchFlag) {
        Message({
          message: "正在下载：" + this.symbol + ",请耐心等待！",
          duration: 2 * 1000
        });
      }

      let content;
      var env = getENV(env);
      if (this.selectedTemplate != "默认模板") {

        const templateData = this.templates.find(template => template.value === this.selectedTemplate);

        const layout = templateData.layout;

        const page = encodeURIComponent(`${env.BASE_URL}/reporter/fund-page?id=${this.symbol}` + `&layout=${layout}`);
        const url = `${env.BASE_URL}/reporter/generate?format=pdf&width=2112&height=1320&page=${page}`;

        let errDefault;
        const resDefault = await axios.get(url).catch((e) => {
          errDefault = e
        });

        if (errDefault) {
          Message({
            message: errDefault.message || errDefault,
            duration: 2 * 1000
          });
          return;
        }


        const resData = resDefault.data;
        if (resData.error) {
          Message({
            message: errDefault.message || errDefault,
            duration: 2 * 1000
          });
          return;
        }

        content = resData.data.content;


      } else {
        let path = encodeURIComponent(`/suitability/v1/funds/fundSheet/${this.symbol}`);
        const url = `./ui-api/v1/generate-reporter?path=${path}`;
        let errDefault;
        const response = await axios.get(url, {
          headers: {
            "X-API-Token": getToken()
          }
        }).catch((e) => {
          errDefault = e
        });

        if (errDefault) {
          Message({
            message: errDefault.message || errDefault,
            duration: 2 * 1000
          });
          return;
        }

        const resData = response.data;
        if (resData.error) {
          Message({
            message: errDefault.message || errDefault,
            duration: 2 * 1000
          });
          return;
        }
        content = resData.data.content;
      }

      //pdf
      const contentType = 'application/pdf';
      this.pdfUrl = `data:${contentType};base64,${content}`;

      if (this.searchFlag) {
        this.searchFlag = false;
        return;
      }

      const link = document.createElement('a');
      link.href = `data:${contentType};base64,${content}`;
      link.download = this.symbol + ".pdf";
      link.click();

    },

    searchFundInformation() {
      const self = this;
      let symbol = self.symbol;
      self.getFundInformation(symbol.replace(/\"/g, "'"));
      self.searchFlag = true;
      self.downloadReport();
    },

    getFundInformation(symbolValue) {
      this.showAddOrRemoveMyList = getMyListTypeByCustom();
      if (!symbolValue)
        return;

      let self = this;
      if (
        symbolValue.indexOf("</span><span class='searchbox_title'>") >
        -1
      ) {
        self.searchPopoverVisible = false;
        symbolValue = symbolValue.split(
          "</span><span class='searchbox_title'>"
        )[0];
        symbolValue = symbolValue
          .replace("<b style='color:red;'>", "")
          .replace("<span class='searchbox_symbol'>", "")
          .replace("</b>", "");
      }

      this.fundId = symbolValue;
      this.symbol = symbolValue;

    },

    searchDataByAutoComplete(queryString) {
      const self = this;
      let results = self.symbolList;
      self.state.length = 0;
      self.state.push(
        "<span class='searchbox_symbol font_bold'>基金代码</span><span class='searchbox_title font_bold'>基金名称</span>"
      );
      if (results !== undefined) {
        for (let i = 0; i < results.length; i++) {
          const value =
            results[i].symbol +
            "    " +
            results[i].name;
          let htmlString = value.replace(
            queryString,
            "<b style='color:red;'>" + queryString + "</b>"
          );
          htmlString = htmlString.replace(
            "    ",
            "</span><span class='searchbox_title'>"
          );

          htmlString = htmlString.replace("未订阅", "<b>未订阅</b>");
          if (i === 0) {
            self.firstSymbol = results[i].symbol;
            self.state.push(
              "<span class='searchbox_symbol'>" +
              htmlString +
              "</span>"
            );
          } else {
            self.state.push(
              "<span class='searchbox_symbol'>" +
              htmlString +
              "</span>"
            );
          }
        }
      }
      if (results === undefined || results.length === 0) {
        self.state.length = 0;
        self.state.push(
          "<span class='font_bold'>抱歉，没有找到和" +
          "<b style='color:red;'>" +
          queryString +
          "</b>" +
          "相关的内容</span>"
        );
      }
      self.$refs.search_scrollbar.update();
    },
  },
};
</script>
<style lang="scss">
.mainArea {
  display: flex;
  gap: 17px;
  align-items: center;
  justify-content: space-between;
}
</style>